<script>
import { authComputed } from '@state/helpers'

import Layout from '@layouts/main'
import Users from '@components/settings-users'
import Roles from '@components/settings-roles'
import Permissions from '@components/settings-permissions'
import Workflows from '@components/settings-workflows'

export default {
  components: { Layout, Users, Roles, Permissions, Workflows },
  props: {
    approverWorkflow: {
      type: Array,
      required: true,
    },
  },
  metaInfo() {
    return {
      title: 'Admin',
      meta: [
        {
          name: 'description',
          content: `Admin settings`,
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <Layout>
    <v-container fluid grid-list-md ma-0>
      <h3>Administration</h3>

      <!-- Tab pane -->
      <v-tabs color="transparent" slider-color="cyan">
        <!-- Tabs -->
        <v-tab v-if="currentUserCanManageUsers">Users</v-tab>
        <v-tab v-if="currentUserCanManageRoles">Roles</v-tab>
        <v-tab v-if="currentUserCanManagePermissions">Permissions</v-tab>
        <v-tab>Approval Workflows</v-tab>

        <!-- Users -->
        <v-tab-item v-if="currentUserCanManageUsers" :class="$style.tabItem">
          <Users />
        </v-tab-item>

        <!-- Roles -->
        <v-tab-item v-if="currentUserCanManageRoles" :class="$style.tabItem">
          <Roles />
        </v-tab-item>

        <!-- Permissions-->
        <v-tab-item
          v-if="currentUserCanManagePermissions"
          :class="$style.tabItem"
        >
          <Permissions />
        </v-tab-item>

        <!-- Approval workflows-->
        <v-tab-item :class="$style.tabItem">
          <Workflows :approverworkflow="approverWorkflow" />
        </v-tab-item>
      </v-tabs>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.tabItem {
  padding-top: 25px;
  border-top: 1px solid gainsboro;
}
</style>
